var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative overflow-hidden bg-white dark:bg-gray-900 text-coolGray-800 dark:text-blueGray-200"},[_c('Hero'),_c('Features',{staticClass:"relative z-10"}),_c('JoinNow'),_c('Faq'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }